import React from 'react';

const SupportIcon = () => {
    return (
        <svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M25.2445 46.1634C36.8632 46.1634 46.282 36.7689 46.282 25.1801C46.282 13.5913 36.8632 4.19678 25.2445 4.19678C13.6258 4.19678 4.20703 13.5913 4.20703 25.1801C4.20703 36.7689 13.6258 46.1634 25.2445 46.1634Z" stroke="url(#paint0_linear_15044_61914)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M25.2451 33.5733C29.8926 33.5733 33.6601 29.8155 33.6601 25.18C33.6601 20.5444 29.8926 16.7866 25.2451 16.7866C20.5976 16.7866 16.8301 20.5444 16.8301 25.18C16.8301 29.8155 20.5976 33.5733 25.2451 33.5733Z" stroke="url(#paint1_linear_15044_61914)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M31.1982 31.1182L40.1181 40.0151" stroke="url(#paint2_linear_15044_61914)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10.3711 40.0151L19.291 31.1182" stroke="url(#paint3_linear_15044_61914)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M31.1982 19.2418L38.6245 11.8347" stroke="url(#paint4_linear_15044_61914)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10.3711 10.3447L19.291 19.2417" stroke="url(#paint5_linear_15044_61914)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <defs>
                <linearGradient id="paint0_linear_15044_61914" x1="1.25283" y1="4.19679" x2="47.7703" y2="5.7379" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#32A6AE" />
                    <stop offset="1" stopColor="#00BBA7" />
                </linearGradient>
                <linearGradient id="paint1_linear_15044_61914" x1="15.6484" y1="16.7866" x2="34.2554" y2="17.4031" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#32A6AE" />
                    <stop offset="1" stopColor="#00BBA7" />
                </linearGradient>
                <linearGradient id="paint2_linear_15044_61914" x1="30.572" y1="31.1182" x2="40.4337" y2="31.4449" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#32A6AE" />
                    <stop offset="1" stopColor="#00BBA7" />
                </linearGradient>
                <linearGradient id="paint3_linear_15044_61914" x1="9.7448" y1="31.1182" x2="19.6065" y2="31.4449" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#32A6AE" />
                    <stop offset="1" stopColor="#00BBA7" />
                </linearGradient>
                <linearGradient id="paint4_linear_15044_61914" x1="30.6768" y1="11.8347" x2="38.8872" y2="12.1067" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#32A6AE" />
                    <stop offset="1" stopColor="#00BBA7" />
                </linearGradient>
                <linearGradient id="paint5_linear_15044_61914" x1="9.7448" y1="10.3447" x2="19.6065" y2="10.6714" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#32A6AE" />
                    <stop offset="1" stopColor="#00BBA7" />
                </linearGradient>
            </defs>
        </svg>
    )
}

export default SupportIcon;